import AboutUsHealthcarePartnersPage from "./AboutUsHealthcarePartnersPage";

export default AboutUsHealthcarePartnersPage;